import DropdownButton from '../DropdownButton';
import CustomTextFieldModal from '../ConfirmReserveModal/CustomTextFieldModal';
import CustomDropDownFieldValuesModal from '../ConfirmReserveModal/CustomDropDownFieldModal';
import { useSpaceContext } from '_/hooks/SpaceContext';
import { sortedFields } from './utils';
import { View } from 'react-native';
import { useState } from 'react';
import { Question } from '_/services/models/forms.model';

interface IQuestionsField {
  form: Question[];
  setForm: React.Dispatch<React.SetStateAction<Question[]>>;
  memberShowCustomFields: boolean | undefined;
}

const QuestionsField = ({ form, setForm, memberShowCustomFields }: IQuestionsField) => {
  const { spaceType } = useSpaceContext();
  const [modalVisibleById, setModalVisibleById] = useState<string | null>(null);
  const fields = sortedFields(form);
  const showCustomFields = memberShowCustomFields && !!fields?.length;

  const handleFieldChange = (id: string, value: string) => {
    setForm((prevValues: Question[]) => {
      const updatedValues = prevValues?.map((field) => {
        if (field.id === id) {
          return { ...field, value };
        }
        return field;
      });
      return updatedValues || [];
    });
  };

  return (
    showCustomFields &&
    fields.map((field) => {
      if (field.type === 'dropdown') {
        return (
          !!field.label && (
            <View key={field.id}>
              <DropdownButton
                text={form?.find((f: Question) => f.id === field.id)?.value || ''}
                icon="help-circle"
                onPress={() => setModalVisibleById(field.id)}
                tag={field.label}
              />
              <CustomDropDownFieldValuesModal
                hideDropdown={() => setModalVisibleById(null)}
                label={field.label}
                setDropdownField={(value) => handleFieldChange(field.id, value)}
                value={form?.find((f: Question) => f.id === field.id)?.value || ''}
                options={field.options}
                visible={modalVisibleById === field.id}
                spaceType={spaceType}
              />
            </View>
          )
        );
      }

      if (field.type === 'text') {
        return (
          !!field.label && (
            <View key={field.id}>
              <DropdownButton
                text={form?.find((f: Question) => f.id === field.id)?.value || ''}
                icon="help-circle"
                onPress={() => setModalVisibleById(field.id)}
                tag={field.label}
              />
              <CustomTextFieldModal
                spaceType={spaceType}
                hideDropdown={() => setModalVisibleById(null)}
                label={field.label}
                setTextFieldValue={(value) => handleFieldChange(field.id, value)}
                value={form?.find((f: Question) => f.id === field.id)?.value || ''}
                visible={modalVisibleById === field.id}
              />
            </View>
          )
        );
      }

      return null;
    })
  );
};

export default QuestionsField;
